import { Fragment, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { Row, Col, Image, Button, Modal } from 'react-bootstrap';

import Topbar from '../components/Topbar';
import RoomCard from '../components/RoomCard';
import RoomCardHorizontal from '../components/RoomCardHorizontal';
import RoomCardPlaceholder from '../components/RoomCardPlaceholder';
import RoomCardHorizontalPlaceholder from '../components/RoomCardHorizontalPlaceholder';
import AboutUsCard from '../components/AboutUsCard';
import MapCard from '../components/MapCard';
import Footer from '../components/Footer';
import espaEL from '../assets/antagonistikotitaframeEL.jpg'
import espaEN from '../assets/antagonistikotitaframeEN.jpg'
import espaPDFEl from '../assets/poster_A3.pdf'
import espaPDFEn from '../assets/poster_A3 αγγλικά.pdf'

import { selectRooms, setSelectedRoom } from '../redux/slices/roomsSlice';
import { useSelector, useDispatch } from 'react-redux';

import banner from '../assets/banner4.png'
import { useTranslation } from 'react-i18next';

import '../styles/homePage.css'

const RoomContainer = ({ rooms, width, colSize }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const handelSelect = (room) => {
        dispatch(setSelectedRoom(room))
        navigate(`/room`);
    }
    
    return (
        <Row className="d-flex justify-content-center">
            {rooms?.length > 0 ? rooms.map(room => 
                <Fragment key={`room-container-${room.id}`}>
                    {width < 1185 ? (  
                        <Col className="col-auto" key={`col-${room.id}`}>
                            <RoomCard key={room.id} {...room} onClick={() => handelSelect(room)}/> 
                        </Col>
                    ) : ( 
                        <Col className="mb-4" xs={colSize} lg={colSize} key={`col-${room.id}`}>
                            <RoomCardHorizontal key={room.id} {...room} onClick={() => handelSelect(room)} mode="double"/> 
                        </Col>
                    )}
                </Fragment>
            ) : (
                <>
                    {width < 1185 ? (  
                        <Col className="col-auto">
                            <RoomCardPlaceholder/>
                            <RoomCardPlaceholder/> 
                            <RoomCardPlaceholder/> 
                        </Col>
                    ) : ( 
                        <Col xs={colSize} lg={colSize}>
                            <RoomCardHorizontalPlaceholder/>
                            <RoomCardHorizontalPlaceholder/> 
                            <RoomCardHorizontalPlaceholder/> 
                        </Col>
                    )}
                </>
            )}
        </Row>
    )
}

const HomePage = () => {
    const roomsData = useSelector(selectRooms)
    const [width, setWidth] = useState(window.innerWidth)
    const [showEspaModal, setShowEspaModal] = useState(false)

    const roomsRef = useRef(null)
    const aboutRef = useRef(null)
    const locationRef = useRef(null)

    const { t, i18n } = useTranslation()
    const lang = i18n.resolvedLanguage

    //Handle Responsiveness  
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        setWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const getColSize = () => {
        if (width > 1520) { return 10 } 
        else return 11 
    }

    return (
        <>
            <div style={{overflowX: 'hidden'}}>
                <div className="espaLogoContainer" onClick={() => setShowEspaModal((prevShowEspaModal) => !prevShowEspaModal)}>
                    <Image src={lang === "el" ? espaEL : espaEN} style={{width: '100%', objectFit: 'contain'}} alt="FooterEspaImage"/>
                </div>

                <Topbar alt="TopBar" aboutRef={aboutRef} roomsRef={roomsRef} locationRef={locationRef} width={width}/>

                <Image className="homePageBanner" src={banner} alt="gem-rooms-main-image"/>

                <div className="bannerTextContainer">
                    <h1 style={{textShadow: '0 0 8px #000', backgroundColor: 'rgb(0,0,0,0.01)'}}>Gem Rooms</h1>
                    <h1 style={{textShadow: '0 0 8px #000', backgroundColor: 'rgb(0,0,0,0.01)'}}>Luxury Apartments</h1>
                    <Button 
                        className="bannerButton"
                        variant='primary' 
                        onClick={() => roomsRef.current?.scrollIntoView({behavior: 'smooth'})}
                    >
                        {t('BOOKNOW')}
                    </Button>
                </div>

                <div ref={aboutRef} className="homePageTextSection">
                    <h2>{t('aboutus')}</h2>
                    <h3>{t('whoWeAreText')}</h3>
                </div>

                <AboutUsCard colSize={5}/>

                <div ref={roomsRef} className="homePageTextSection">
                    <h2>{t('ourRooms')}</h2>
                    <h3>{t('ourRoomsText')}</h3>
                </div>

                <div className="d-flex justify-content-center">
                    <RoomContainer rooms={roomsData} width={width} colSize={getColSize()} locationRef={locationRef}/>
                </div>

                <div ref={locationRef} className="homePageTextSection" style={{backgroundColor: '#1E1E1E', color: '#fff', width: '100%', marginBottom: '-3rem'}}>
                    <h2>{t('contactUs')}</h2>
                    <h3>{t('contactTextFlavour')}</h3>
                </div>

                <MapCard />

                <Footer alt="Footer"/>
            </div>

            <Modal size="xl" show={showEspaModal} onHide={() => setShowEspaModal(false)}>
                <div style={{height: '54rem'}}>
                    <object data={lang === 'el' ? espaPDFEl : espaPDFEn} type="application/pdf" width="100%" height="100%"/>
                </div>
            </Modal>
        </>
    )
}

export default HomePage